/**
 * Branch Data Migration Script
 * 
 * This script populates the Firestore database with initial branch data.
 * Run this once to migrate from hardcoded branch data to Firestore.
 * 
 * To run this script:
 * 1. Make sure you're logged in to Firebase in your browser
 * 2. Temporarily modify firestore.rules to allow write access (or run as admin)
 * 3. Run this in the browser console on your app, or create a temporary admin page
 * 
 * IMPORTANT: This is a one-time migration script. Remove or secure it after use.
 */

import { collection, doc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';

export const migrateBranchData = async () => {
  const branches = [
    {
      id: 'main-branch',
      name: 'Main Branch',
      address: 'Purok 4, Barangay 5, San Francisco Agusan del Sur',
      mapUrl: 'https://maps.app.goo.gl/jcmNwY21jCMLBaqH8',
      order: 1,
      isActive: true
    },
    {
      id: 'trento-branch',
      name: 'Trento Branch',
      address: 'Pan-Philippine Highway, Trento, Agusan del Sur',
      mapUrl: 'https://maps.app.goo.gl/WF3PxEPKUVcirBZD8',
      order: 2,
      isActive: true
    },
    {
      id: 'nabunturan-branch',
      name: 'Nabunturan Branch',
      address: 'H.M. Tan Bldg. Purok 7, Arabeo St., Davao de Oro',
      mapUrl: 'https://maps.app.goo.gl/pNGYSFZfXB2DctsA9',
      order: 3,
      isActive: true
    }
  ];

  try {
    console.log('Starting branch data migration...');
    
    for (const branch of branches) {
      const { id, ...branchData } = branch;
      await setDoc(doc(collection(db, 'branches'), id), branchData);
      console.log(`✓ Migrated: ${branch.name}`);
    }
    
    console.log('✓ Branch data migration completed successfully!');
    return { success: true, message: 'All branches migrated successfully' };
  } catch (error) {
    console.error('✗ Error during migration:', error);
    return { success: false, error };
  }
};

// Export branch data for reference
export const INITIAL_BRANCHES = [
  {
    id: 'main-branch',
    name: 'Main Branch',
    address: 'Purok 4, Barangay 5, San Francisco Agusan del Sur',
    mapUrl: 'https://maps.app.goo.gl/jcmNwY21jCMLBaqH8',
    order: 1,
    isActive: true
  },
  {
    id: 'trento-branch',
    name: 'Trento Branch',
    address: 'Pan-Philippine Highway, Trento, Agusan del Sur',
    mapUrl: 'https://maps.app.goo.gl/WF3PxEPKUVcirBZD8',
    order: 2,
    isActive: true
  },
  {
    id: 'nabunturan-branch',
    name: 'Nabunturan Branch',
    address: 'H.M. Tan Bldg. Purok 7, Arabeo St., Davao de Oro',
    mapUrl: 'https://maps.app.goo.gl/pNGYSFZfXB2DctsA9',
    order: 3,
    isActive: true
  }
];
